import { render, staticRenderFns } from "./Contagens.vue?vue&type=template&id=7f62f848"
import script from "./Contagens.vue?vue&type=script&lang=js"
export * from "./Contagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports